import { EllipsedText, FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { LabelSmall, ParagraphXSmall } from 'baseui/typography';
import { memo } from 'react';
import { generatePath } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { GPT_DETAIL_PAGE } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { workspaceState } from '../../storage/app';
import { EventCore } from '../../types/gptTypes';
import { StyledTooltip } from '../ui/StyledTooltip';

type Props = {
  event: EventCore;
};

function GptEventCardHeader({ event }: Readonly<Props>) {
  const { theme, css } = useStyles();
  const workspace = useRecoilValue(workspaceState);

  return (
    <FlexRow
      classNames={css({
        padding: `${theme.sizing.scale200} ${theme.sizing.scale400} ${theme.sizing.scale200}`,
        alignItems: 'center',
      })}
    >
      <FlexRow
        gap={theme.sizing.scale200}
        classNames={css({ flexGrow: 1 })}
      >
        <StyledTooltip
          content="Dispositivo"
          showArrow={false}
          placement="bottom"
          ignoreBoundary
        >
          <LabelSmall margin={'2px 0 0'}>
            <EllipsedText
              breakAll
              inline
            >
              {event.ident}
            </EllipsedText>
          </LabelSmall>
        </StyledTooltip>
        <StyledTooltip
          content="Tipo de evento"
          showArrow={false}
          placement="bottom"
          ignoreBoundary
        >
          <ParagraphXSmall
            margin={0}
            color={theme.colors.contentSecondary}
          >
            <EllipsedText
              breakAll
              inline
            >
              {`- ${event.eventName}`}
            </EllipsedText>
          </ParagraphXSmall>
        </StyledTooltip>
      </FlexRow>
      <FlexRow gap={theme.sizing.scale800}>
        <LabelSmall className={css({ textWrap: 'nowrap' })}>
          {event.totalAlarms} {`${event.totalAlarms === 1 ? 'Alarma' : 'Alarmas'}`}
        </LabelSmall>
      </FlexRow>
      <FlexRow gap={0}>
        <StyledTooltip
          content="Abrir seguimiento"
          showArrow={false}
          placement="bottom"
          ignoreBoundary
        >
          <Button
            shape="circle"
            kind="tertiary"
            size="mini"
            onClick={() => {
              if (workspace) {
                window.open(
                  generatePath(GPT_DETAIL_PAGE.route, { id: workspace._id, eventId: event._id }),
                  '_blank',
                  'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no, height=1170px, width=1820px',
                );
              }
            }}
          >
            <MaterialIcon
              name="open_in_new"
              size="16px"
            />
          </Button>
        </StyledTooltip>
      </FlexRow>
    </FlexRow>
  );
}

export default memo(GptEventCardHeader);
